interface IconProps {
  s?: number;
  c?: string;
  w?: number;
  fill?: string;
}

export const Icon = {
  heart: ({ s = 24, c = 'currentColor', w = 1.8, fill = 'none' }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 20s-7-4.5-7-10a4 4 0 017-2.6A4 4 0 0119 10c0 5.5-7 10-7 10z" fill={fill} />
    </svg>
  ),
  x: ({ s = 24, c = 'currentColor', w = 1.8 }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round">
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  ),
  star: ({ s = 24, c = 'currentColor', w = 1.8, fill = 'none' }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3l2.6 5.8L21 9.5l-4.7 4.1L17.7 20 12 16.8 6.3 20l1.4-6.4L3 9.5l6.4-.7L12 3z" fill={fill} />
    </svg>
  ),
  undo: ({ s = 24, c = 'currentColor', w = 1.8 }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 10h10a5 5 0 015 5v0a5 5 0 01-5 5h-4M4 10l4-4M4 10l4 4" />
    </svg>
  ),
  bolt: ({ s = 24, c = 'currentColor', w = 1.8, fill = 'none' }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" fill={fill} />
    </svg>
  ),
  sparkle: ({ s = 24, c = 'currentColor', w = 1.6, fill = 'none' }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5L18 18M6 18l2.5-2.5M15.5 8.5L18 6" />
      <circle cx="12" cy="12" r="2.5" fill={fill} />
    </svg>
  ),
  flame: ({ s = 24, c = 'currentColor', w = 1.8, fill = 'none' }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2s5 4 5 10a5 5 0 11-10 0c0-2 1-3 1-5 0 2 2 3 4 3 0-3-2-5 0-8z" fill={fill} />
    </svg>
  ),
  cap: ({ s = 24, c = 'currentColor', w = 1.8 }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 9l10-5 10 5-10 5L2 9z" />
      <path d="M6 11v5c0 1.5 2.7 3 6 3s6-1.5 6-3v-5" />
      <path d="M22 9v6" />
    </svg>
  ),
  pin: ({ s = 24, c = 'currentColor', w = 1.8 }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s-7-7.5-7-13a7 7 0 0114 0c0 5.5-7 13-7 13z" />
      <circle cx="12" cy="9" r="2.5" />
    </svg>
  ),
  chat: ({ s = 24, c = 'currentColor', w = 1.8, fill = 'none' }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 5h16v11H9l-5 4V5z" fill={fill} />
    </svg>
  ),
  user: ({ s = 24, c = 'currentColor', w = 1.8, fill = 'none' }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="4" fill={fill} />
      <path d="M4 21c1-5 4-7 8-7s7 2 8 7" />
    </svg>
  ),
  compass: ({ s = 24, c = 'currentColor', w = 1.8 }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M15.5 8.5L13.5 13.5 8.5 15.5 10.5 10.5z" />
    </svg>
  ),
  back: ({ s = 24, c = 'currentColor', w = 1.8 }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 18l-6-6 6-6" />
    </svg>
  ),
  more: ({ s = 24, c = 'currentColor' }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={1.8} strokeLinecap="round">
      <circle cx="5" cy="12" r="1.5" fill={c} />
      <circle cx="12" cy="12" r="1.5" fill={c} />
      <circle cx="19" cy="12" r="1.5" fill={c} />
    </svg>
  ),
  edit: ({ s = 24, c = 'currentColor', w = 1.8 }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 20l4-1 11-11-3-3L5 16l-1 4z" />
    </svg>
  ),
  check: ({ s = 24, c = 'currentColor', w = 2 }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 12l5 5L20 6" />
    </svg>
  ),
  clock: ({ s = 24, c = 'currentColor', w = 1.8 }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  ),
  london: ({ s = 24, c = 'currentColor', w = 1.6 }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 22V9h4v13M10 9l2-6 2 6M11 13h2M11 16h2M7 22h10" />
    </svg>
  ),
  arrow: ({ s = 24, c = 'currentColor', w = 1.8 }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  ),
  plus: ({ s = 24, c = 'currentColor', w = 1.8 }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round">
      <path d="M12 5v14M5 12h14" />
    </svg>
  ),
  sun: ({ s = 24, c = 'currentColor', w = 1.8 }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4 12H2M22 12h-2M5 5l1.5 1.5M17.5 17.5L19 19M5 19l1.5-1.5M17.5 6.5L19 5" />
    </svg>
  ),
  moon: ({ s = 24, c: _c = 'currentColor', fill = 'currentColor' }: IconProps = {}) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill={fill}>
      <path d="M12 3a9 9 0 109 9 7 7 0 01-9-9z" />
    </svg>
  ),
};
